import _SvgIcon from "@mui/material/SvgIcon";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
export function ExclusionZonesLegendIcon(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon, _extends({
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15475_117277)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFE24C",
    height: "10",
    transform: "translate(0 10.5)",
    width: "32"
  }), /*#__PURE__*/React.createElement("mask", {
    height: "33",
    id: "mask0_15475_117277",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'alpha'
    },
    width: "32",
    x: "0",
    y: "0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H32V32.5H0V0.5Z",
    fill: "#FFE24C"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15475_117277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6719 34.8285L34.329 31.1714M14.6719 34.8285L34.329 15.1714M0.500446 33L32.5004 0.999958M-1.32812 18.8285L18.329 -0.828613M-1.32812 2.82853L2.32902 -0.828613",
    stroke: "#C88400",
    strokeWidth: "4.57143"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15475_117277"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    height: "10",
    transform: "translate(0 10.5)",
    width: "32"
  }))));
}